@if (catalog(); as catalog) {
  <se-fe-modal-button [seFeDataButton]="editButton" (seFeButtonAction)="open($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="pencil_fill"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="Edit catalog settings"></se-fe-icon>
  </se-fe-modal-button>

  <app-catalog-form-modal
    #catalogFormModal
    modalTitle="Edit catalog"
    savingLabel="Updating catalog"
    [initialValue]="catalog"
    [saving]="updating()"
    [errorMessage]="updateError()?.message ?? ''"
    (save)="updateCatalog($event)"></app-catalog-form-modal>
}
